<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <!-- <el-button-group class="mb-3">
      <search-form :fields="search" />
    </el-button-group> -->

    <el-row type="flex" justify="left">
      <el-col :span="20">
        <search-form :fields="search" />
        <el-popconfirm
          confirm-button-text="确定"
          cancel-button-text="取消"
          icon="el-icon-info"
          icon-color="red"
          title="确认离线导出么？"
          @confirm="rsyncExport()"
          v-if="hasPermsOrderImportsExport"
        >
          <el-button slot="reference"><i class="el-icon-download" />离线导出</el-button>
        </el-popconfirm>
        <button-link v-if="hasPermsOrderImportsExport" :to="`downloads`"><i class="el-icon-download" />下载中心</button-link>
      </el-col>
      <el-col :span="4">
        <span class="text item" v-if="hasPermsOrderImportsOrderOffline">
          <el-tooltip class="item" effect="dark" content="会将该批次销售单生成线下订单，此操作不可撤销，请谨慎操作。" placement="top">
            <el-popconfirm title="确认无误，开始生成线下订单？" @confirm="onSubmitOrders()">
              <el-button type="primary" slot="reference"><i class="el-icon-s-promotion" />生成线下订单</el-button>
            </el-popconfirm>
          </el-tooltip>
        </span>
      </el-col>
    </el-row>

    <el-divider content-position="left">销售单明细列表</el-divider>
    <!-- <el-alert title="重复检测只会导入时检测" type="warning" :closable="false" /> -->
    <el-table :data="orderImports" resource="order-imports">
      <el-table-column prop="id" label="序号" width="50" align="center" />
      <el-table-column prop="warehouse_code" label="所属仓库" width="150">
        <template #default="{ row }">
          {{ row.warehouse.name }}
        </template>
      </el-table-column>

      <el-table-column prop="pay_time" label="日期" width="170" />
      <el-table-column prop="username" label="购买账户" width="120" />
      <el-table-column prop="order_items" label="产品信息">
        <template #default="{ row }">
          <el-tag v-for="good in row.goods" :key="good.mdkey">{{ good.name }}*{{ good.nums }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="ship_addr" label="收件地址" /> -->
      <el-table-column prop="ship_addr" label="收货地址">
        <template #default="{ row }">
          <span>{{ row.ship_name }}</span> / <span>{{ row.ship_mobile }}</span>
          <br />
          <span>{{ row.ship_addr }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="导入状态" width="100">
        <template #default="{ row }">
          <!-- 默认 1 待处理,2 重复数据,3 数据不完整,4 快递公司不在范围内,5 商品解析异常,6 地址解析异常,7 上传中,8 上传成功,9 上传失败 -->
          <el-tag :type="getStatusTag(row.status).type">{{ getStatusTag(row.status).message }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="发货状态" width="100">
        <template #default="{ row }">
          <!-- status -->
          <el-tag v-if="row.order" size="small" disable-transitions>
            {{ getOrderStatusTag(row.order.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="order_id" label="线下订单号">
        <template #default="{ row }">
          <router-link v-if="row.order_id" :to="'/order-offline/' + row.order.id + '/edit'">
            <el-tooltip class="item" effect="dark" content="点击查看详情" placement="top">
              <el-button type="text" size="small">{{ row.order_id }}</el-button>
            </el-tooltip>
          </router-link>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="导入时间" width="170" />
      <!-- <el-table-column prop="updated_at" label="操作时间" width="170" /> -->
      <el-table-column label="操作" width="90">
        <template #default="{ row, $index }">
          <el-button-group>
            <row-destroy v-if="hasPermsOrderImportDetailsDelete && row.status != 8" />
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer">
      <pagination :page="page" />
    </div>
  </el-card>
</template>

<script>
import { getOrderImportDetails } from '@/api/order-import-details'
import { exportOrder, importOrderOffline } from '@/api/order-imports'
import { warehouseList } from '@/api/warehouses'
import { can, getFirstError } from '@/libs/utils'
import ButtonLink from '@c/ButtonLink'
import RowDestroy from '@c/LzTable/RowDestroy'
// import RowToEdit from '@c/LzTable/RowToEdit'
import Pagination from '@c/Pagination'
import SearchForm from '@c/SearchForm'

export default {
  name: 'Index',
  components: {
    // RowToEdit,
    ButtonLink,
    RowDestroy,
    SearchForm,
    Pagination,
  },
  data() {
    return {
      search: [
        {
          field: 'express',
          label: '收件信息(手机、姓名)',
        },
        {
          field: 'username',
          label: '购买账户',
        },
        {
          field: 'status',
          label: '状态',
          type: 'el-select',
          options: [
            {
              id: '1',
              name: '待处理',
            },
            {
              id: '2',
              name: '重复数据',
            },
            {
              id: '3',
              name: '数据不完整',
            },
            // {
            //   id: '4',
            //   name: '快递公司不在范围内',
            // },
            {
              id: '5',
              name: '商品解析异常',
            },
            // {
            //   id: '6',
            //   name: '地址解析异常',
            // },
            {
              id: '7',
              name: '上传中',
            },
            {
              id: '8',
              name: '上传成功',
            },
            {
              id: '9',
              name: '上传失败',
            },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'created_at',
          label: '导入时间',
          type: 'el-date-picker',
        },
        {
          field: 'order_id',
          label: '线下订单号',
        },
      ],
      orderImports: [],
      page: null,

      // 默认 1 待处理,2 重复数据,3 数据不完整,4 快递公司不在范围内,5 商品解析异常,6 地址解析异常,7 上传中,8 上传成功,9 上传失败

      status: '',

      query: {},
      warehouse_code: '',
      warehouseList: [],

      // 权限
      // 生成订单
      hasPermsOrderImportsOrderOffline: false,
      // 导出物流信息
      hasPermsOrderImportsExport: false,
      // 删除销售订单
      hasPermsOrderImportDetailsDelete: false,
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query
        this.loadData()
      },
      immediate: true,
    },
  },
  created() {
    // 生成订单
    this.hasPermsOrderImportsOrderOffline = can('order.imports.order.offline')
    // 导出物流信息
    this.hasPermsOrderImportsExport = can('order.imports.export')
    // 删除销售订单
    this.hasPermsOrderImportDetailsDelete = can('order-import-details.delete')

    this.loadWarehouse()
  },
  methods: {
    async loadWarehouse() {
      const { data } = await warehouseList()
      console.log(data)
      this.warehouseList = data
    },
    async loadData() {
      const {
        data: { data, meta },
      } = await getOrderImportDetails(this.query)
      this.orderImports = data
      this.page = meta
    },
    // 默认 1 待处理,2 重复数据,3 数据不完整,4 快递公司不在范围内,5 商品解析异常,6 地址解析异常,7 上传中,8 上传成功,9 上传失败
    getStatusTag(status) {
      let tag = {
        type: 'info',
        message: '待处理',
      }
      switch (status) {
        case 2:
          tag = {
            type: 'warning',
            message: '重复数据',
          }
          break
        case 3:
          tag = {
            type: 'warning',
            message: '商品解析异常',
          }
          break
        case 4:
          tag = {
            type: 'warning',
            message: '快递公司不在范围内',
          }
          break
        case 5:
          tag = {
            type: 'warning',
            message: '商品解析异常',
          }
          break
        case 6:
          tag = {
            type: 'success',
            message: '地址解析异常',
          }
          break
        case 7:
          tag = {
            type: 'default',
            message: '上传中',
          }
          break
        case 8:
          tag = {
            type: 'success',
            message: '上传成功',
          }
          break
        case 9:
          tag = {
            type: 'danger',
            message: '上传失败',
          }
          break
        default:
          break
      }
      return tag
    },

    getOrderStatusTag(status) {
      const statusList = {
        0: '待发货',
        1: '发货中',
        2: '已完成',
      }

      return statusList[status]
    },

    async onSubmitOrders() {
      const that = this

      const form = {
        batch_no: that.query.batch_no,
      }

      console.log('form:', form)

      const res = await importOrderOffline(form)
      console.log(res)
      if (res.status === 201) {
        that.$message({
          message: '处理完成',
          type: 'success',
        })
      } else {
        that.$message({
          message: res.data.msg,
          type: 'error',
        })
      }

      // 更新本地
      that.loadData()
    },

    async rsyncExport() {
      try {
        await exportOrder({ ...this.query })
        this.$message.success('离线下载中...')
      } catch (e) {
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
    },
  },
}
</script>
